module.exports = __webpack_public_path__ + "static/media/Bellerophon.106df155.jpg";